module.exports = __webpack_public_path__ + "static/media/Integracao.fea476b2.jpg";